import * as React from 'react';
import styles from './index.less';
// import img from '@/assets/file-object.svg';
import FComponentsLib from '@freelog/components-lib';
import { connect } from 'dva';
import { ConnectState, ResourceCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import { FI18n, FUtil } from '@freelog/tools-lib';
import fResourcePropertyEditor3 from '@/components/fResourcePropertyEditor3';
import FTooltip from '@/components/FTooltip';
import {
  OnChange_step2_customConfigurations_Action,
  OnChange_step2_customProperties_Action,
  OnClick_step2_editCartoonBtn_Action,
  OnClick_step2_editMarkdownBtn_Action,
  OnClick_step2_submitBtn_Action,
  OnClose_step2_editMarkdown,
  OnRemove_step2_file_Action,
  OnSucceed_step2_localUpload_Action,
  OnSucceed_step2_storageSpace_Action,
  OnTrigger_step2_SaveDraft_Action,
  ChangeAction,
  OnClose_step2_editCartoon_Action,
  OnChange_step2_systemProperties_Action,
} from '@/models/resourceCreatorPage';
import { history } from '@@/core/history';
import FLocalUpload from '@/components/FLocalUpload';
import FStorageSpace from '@/components/FStorageSpace';
import FResourceMarkdownEditor from '@/components/FResourceMarkdownEditor';
import FResourceCartoonEditor from '@/components/FResourceCartoonEditor';
import { Progress, Space } from 'antd';
import { useGetState } from '@/utils/hooks';
import fResourceOptionEditor from '@/components/fResourceOptionEditor';
import FResourceOptions from '@/components/FResourceOptions';
import * as AHooks from 'ahooks';
// import FSkeletonNode from '@/components/FSkeletonNode';
import FMicroApp_MarkdownEditorDrawer from '@/components/FMicroApp_MarkdownEditorDrawer';
import FMicroAPP_Authorization from '@/components/FMicroAPP_Authorization';
import fPromiseModalConfirm from '@/components/fPromiseModalConfirm';
import FMicroApp_CartoonEditorDrawer from '@/components/FMicroApp_CartoonEditorDrawer';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import FIcons from '@/components/FIcons';
import FTextBtn from '@/components/FButton/FTextBtn';
import FAttrsAndConfigs, { IAttrsAndConfigsItem } from '@/components/FAttrsAndConfigs';
import FFileIcon from '@/components/FFileIcon';
import FUploadCover from '@/components/FUploadCover';

interface Step2Props {
  dispatch: Dispatch;
  resourceCreatorPage: ResourceCreatorPageModelState;
}

function Step2({ dispatch, resourceCreatorPage }: Step2Props) {
  const [$showMore, set$ShowMore, get$ShowMore] = useGetState<boolean>(false);
  const [$uploadingInfo, set$uploadingInfo, get$uploadingInfo] = useGetState<null | {
    name: string;
    percent: number;
    cancelHandler: any;
  }>(null);

  // 视频类型资源上传封面：资源类型名称包含「视频」时展示上传入口
  const isVideoResource: boolean = (
    resourceCreatorPage.step1_createdResourceInfo?.resourceType || []
  ).some((t) => t.includes('视频'));

  AHooks.useDebounceEffect(
    () => {
      if (resourceCreatorPage.step2_dataIsDirty_count !== 0) {
        dispatch<OnTrigger_step2_SaveDraft_Action>({
          type: 'resourceCreatorPage/onTrigger_step2_SaveDraft',
        });
      }
    },
    [resourceCreatorPage.step2_dataIsDirty_count],
    {
      wait: 300,
    },
  );

  AHooks.useDebounceEffect(
    () => {
      if (
        !(!resourceCreatorPage.step2_fileInfo || !resourceCreatorPage.step2_isCompleteAuthorization)
      ) {
        fSetHotspotTooltipVisible('resourceCreator.step2.submitButton', {
          value: true,
          effectiveImmediately: true,
          onlyNullish: true,
        });
      }
    },
    [resourceCreatorPage.step2_fileInfo, resourceCreatorPage.step2_isCompleteAuthorization],
    {
      wait: 10,
    },
  );

  return (
    <>
      <div
        style={{
          display: !resourceCreatorPage.step2_fileInfo && !!$uploadingInfo ? 'block' : 'none',
        }}
      >
        <div style={{ height: 40 }} />
        <div className={styles.fileInfo}>
          <div className={styles.card}>
            {/* <img src={img} className={styles.img} alt='' /> */}
            <FFileIcon mime={''} sha1={''} />
            <div style={{ width: 20 }} />
            <div>
              <FComponentsLib.FContentText
                type='highlight'
                text={$uploadingInfo?.name || ''}
                style={{ maxWidth: 600 }}
                singleRow
              />
              <div style={{ height: 18 }} />
              <div className={styles.info}>
                <FComponentsLib.FContentText
                  className={styles.infoSize}
                  type='additional1'
                  text={'本地上传'}
                />
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', width: 270 }}>
            <FComponentsLib.FContentText
              text={`${($uploadingInfo?.percent || 0) > 99 ? 99 : $uploadingInfo?.percent || 0}%`}
              type={'additional1'}
              style={{ color: '#222' }}
            />
            <div style={{ width: 10 }} />
            <Progress
              percent={($uploadingInfo?.percent || 0) > 99 ? 99 : $uploadingInfo?.percent || 0}
              showInfo={false}
              style={{ width: 140 }}
            />
            <div style={{ width: 20 }} />
            {/* {$uploadingInfo?.percent === 100 ? (
              <FComponentsLib.FTextBtn style={{ fontSize: 12 }} type={'primary'}>
                正在解析
              </FComponentsLib.FTextBtn>
            ) : ( */}
            <FComponentsLib.FTextBtn
              style={{ fontSize: 12 }}
              type={'danger'}
              onClick={() => {
                const uploadingInfo = get$uploadingInfo();
                uploadingInfo && uploadingInfo.cancelHandler();
                set$uploadingInfo(null);
              }}
            >
              取消上传
            </FComponentsLib.FTextBtn>
          </div>
        </div>
      </div>

      <div
        style={{
          display: !resourceCreatorPage.step2_fileInfo && !$uploadingInfo ? 'block' : 'none',
        }}
      >
        <div style={{ height: 40 }} />
        <div className={styles.styles}>
          {resourceCreatorPage.step2_resourceTypeConfig.uploadEntry.includes('localUpload') && (
            <FLocalUpload
              style={{ width: '100%', flexGrow: 1 }}
              limitFileSize={resourceCreatorPage.step2_resourceTypeConfig.limitFileSize}
              resourceTypeCode={
                resourceCreatorPage.step1_createdResourceInfo?.resourceTypeCode || ''
              }
              onSucceed={(value) => {
                dispatch<OnSucceed_step2_localUpload_Action>({
                  type: 'resourceCreatorPage/onSucceed_step2_localUpload',
                  payload: {
                    fileName: value.fileName,
                    sha1: value.sha1,
                  },
                });
              }}
              onChange_uploadingInfo={(value) => {
                set$uploadingInfo(value);
              }}
            />
          )}

          {resourceCreatorPage.step2_resourceTypeConfig.uploadEntry.includes('storageSpace') && (
            <FStorageSpace
              style={{ width: '100%', flexGrow: 1 }}
              resourceTypeCode={
                resourceCreatorPage.step1_createdResourceInfo?.resourceTypeCode || ''
              }
              onSucceed={(value) => {
                dispatch<OnSucceed_step2_storageSpace_Action>({
                  type: 'resourceCreatorPage/onSucceed_step2_storageSpace',
                  payload: value,
                });
              }}
            />
          )}

          {resourceCreatorPage.step2_resourceTypeConfig.uploadEntry.includes('markdownEditor') && (
            <FResourceMarkdownEditor
              style={{ width: '100%', flexGrow: 1 }}
              onClickBtn={() => {
                dispatch<OnClick_step2_editMarkdownBtn_Action>({
                  type: 'resourceCreatorPage/onClick_step2_editMarkdownBtn',
                });
              }}
            />
          )}

          {resourceCreatorPage.step2_resourceTypeConfig.uploadEntry.includes('cartoonEditor') && (
            <FResourceCartoonEditor
              style={{ width: '100%', flexGrow: 1 }}
              onClickBtn={() => {
                dispatch<OnClick_step2_editCartoonBtn_Action>({
                  type: 'resourceCreatorPage/onClick_step2_editCartoonBtn',
                });
              }}
            />
          )}
        </div>

        <div style={{ height: 30 }} />

        <div className={styles.btn}>
          <FComponentsLib.FTextBtn
            type={'default'}
            onClick={() => {
              history.push(
                FUtil.LinkTo.resourceVersionInfo({
                  resourceID: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
                }),
              );
            }}
          >
            {FI18n.i18nNext.tAuto('rqr_step2_btn_later')}
          </FComponentsLib.FTextBtn>
          <FComponentsLib.FRectBtn
            disabled={!resourceCreatorPage.step2_fileInfo}
            type={'primary'}
            onClick={() => {
              dispatch<OnClick_step2_submitBtn_Action>({
                type: 'resourceCreatorPage/onClick_step2_submitBtn',
              });
            }}
          >
            {FI18n.i18nNext.tAuto('rqr_step2_btn_next')}
          </FComponentsLib.FRectBtn>
        </div>

        <div style={{ height: 100 }} />
      </div>
      <div
        style={{
          display: resourceCreatorPage.step2_fileInfo ? 'block' : 'none',
        }}
      >
        <div style={{ height: 40 }} />

        <div className={styles.blockCard}>
          <div className={styles.baseInfo}>
            <div className={styles.baseInfoLeft}>
              <div
                className={[
                  styles.baseInfoLeftIcon,
                  (() => {
                    if (resourceCreatorPage.step2_videoCover) {
                      return styles.baseInfoLeftIcon_withImage;
                    }
                    const mime =
                      resourceCreatorPage.step2_systemProperties.find(
                        (sp) => sp.key === 'mime',
                      )?.value || '';
                    const sha1 = resourceCreatorPage.step2_fileInfo?.sha1 || '';
                    const hasCover =
                      (mime?.startsWith('image/') || mime?.startsWith('video/')) && !!sha1;
                    return hasCover
                      ? styles.baseInfoLeftIcon_withImage
                      : styles.baseInfoLeftIcon_iconOnly;
                  })(),
                ].join(' ')}
              >
                {resourceCreatorPage.step2_videoCover ? (
                  <img src={resourceCreatorPage.step2_videoCover} alt='' />
                ) : (
                  <FFileIcon
                    mime={
                      resourceCreatorPage.step2_systemProperties.find(
                        (sp) => sp.key === 'mime',
                      )?.value || ''
                    }
                    sha1={resourceCreatorPage.step2_fileInfo?.sha1 || ''}
                  />
                )}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                <FComponentsLib.FContentText
                  type='highlight'
                  text={resourceCreatorPage.step2_fileInfo?.name || ''}
                  style={{ maxWidth: 400, fontSize: 14, fontWeight: 600, color: '#222' }}
                  singleRow
                />
                {resourceCreatorPage.step2_fileInfo?.from !== '上个版本' && (
                  <FComponentsLib.FContentText
                    type='additional2'
                    style={{ maxWidth: 400, fontSize: 12, color: '#999' }}
                    text={(() => {
                      const from = resourceCreatorPage.step2_fileInfo?.from || '';
                      if (from === '本地上传') {
                        // 本地上传来源说明
                        return FI18n.i18nNext.t('createversion_object_fromlocal');
                      }
                      if (from === '存储空间') {
                        // 存储空间来源说明
                        return FI18n.i18nNext.t('createversion_object_fromstorage');
                      }
                      if (from.startsWith('最近编辑时间')) {
                        return `${
                          // 最近修改时间前缀
                          FI18n.i18nNext.tAuto('createversion_object_lastmodified')
                        } ${from.slice(6).trim()}`;
                      }
                      return from;
                    })()}
                    singleRow
                  />
                )}
              </div>
            </div>
            <div className={styles.baseInfoRight}>
              {resourceCreatorPage.step2_resourceTypeConfig.isSupportEdit && (
                <FTextBtn
                  type='primary'
                  size='default'
                  disabled={resourceCreatorPage.step2_systemPropertiesState === 'parsing'}
                  onClick={async () => {
                    if (
                      resourceCreatorPage.step2_resourceTypeConfig.uploadEntry.includes(
                        'markdownEditor',
                      )
                    ) {
                      dispatch<OnClick_step2_editMarkdownBtn_Action>({
                        type: 'resourceCreatorPage/onClick_step2_editMarkdownBtn',
                      });
                    } else if (
                      resourceCreatorPage.step2_resourceTypeConfig.uploadEntry.includes(
                        'cartoonEditor',
                      )
                    ) {
                      dispatch<OnClick_step2_editCartoonBtn_Action>({
                        type: 'resourceCreatorPage/onClick_step2_editCartoonBtn',
                      });
                    }
                  }}
                >
                  <FIcons.FEdit style={{ fontSize: 14, color: 'inherit' }} />
                  <span>
                    {
                      // 编辑
                      FI18n.i18nNext.tAuto('createversion_btn_edit')
                    }
                  </span>
                </FTextBtn>
              )}

              {resourceCreatorPage.step2_resourceTypeConfig.isSupportDownload && (
                <FTextBtn
                  type='primary'
                  size='default'
                  disabled={resourceCreatorPage.step2_systemPropertiesState === 'parsing'}
                  onClick={() => {
                    if (!resourceCreatorPage.step2_fileInfo) {
                      return;
                    }
                    self.location.href =
                      FUtil.Format.completeUrlByDomain('api') +
                      `/v2/storages/files/${
                        resourceCreatorPage.step2_fileInfo?.sha1 || ''
                      }/download?attachmentName=${
                        resourceCreatorPage.step2_fileInfo?.name || 'download'
                      }`;
                  }}
                >
                  <FIcons.FDownload style={{ fontSize: 14, color: 'inherit' }} />
                  <span>
                    {
                      // 下载
                      FI18n.i18nNext.tAuto('edit_resource_vmgnt_btn_download')
                    }
                  </span>
                </FTextBtn>
              )}

              <FTextBtn
                type='danger'
                size='default'
                disabled={resourceCreatorPage.step2_systemPropertiesState === 'parsing'}
                onClick={async () => {
                  const confirm: boolean = await fPromiseModalConfirm({
                    // 删除文件确认无需标题
                    title: '',
                    // 确定要移除此项吗？
                    description: FI18n.i18nNext.t('createversion_remove_file_confirmation'),
                    // 移除
                    okText: FI18n.i18nNext.t('createversion_remove_file_btn_remove'),
                    // 取消
                    cancelText: FI18n.i18nNext.t('btn_cancel'),
                  });
                  if (confirm) {
                    dispatch<OnRemove_step2_file_Action>({
                      type: 'resourceCreatorPage/onRemove_step2_file',
                    });
                  }
                }}
              >
                <FIcons.FDelete style={{ fontSize: 14, color: 'inherit' }} />
                <span>
                  {
                    // 删除
                    FI18n.i18nNext.tAuto('remove')
                  }
                </span>
              </FTextBtn>
            </div>
          </div>

          {isVideoResource && (
            <div className={styles.videoCoverRow}>
              <FUploadCover
                use={'resource'}
                onUploadSuccess={(url) => {
                  dispatch<ChangeAction>({
                    type: 'resourceCreatorPage/change',
                    payload: {
                      step2_videoCover: url,
                      step2_dataIsDirty_count:
                        resourceCreatorPage.step2_dataIsDirty_count + 1,
                    },
                  });
                }}
              >
                <span className={styles.videoCoverBtn}>
                  {resourceCreatorPage.step2_videoCover ? '更换视频封面' : '上传视频封面'}
                </span>
              </FUploadCover>
            </div>
          )}
        </div>

        <div style={{ height: 5 }} />

        {/* {resourceCreatorPage.step2_systemPropertiesState === 'parsing' && (
          <>
            <div style={{ height: 20 }} />
            <FSkeletonNode width={920} height={38} />
            <div style={{ height: 20 }} />
            <FSkeletonNode width={340} height={38} />
          </>
        )} */}

        {/* {resourceCreatorPage.step2_systemPropertiesState === 'success' && (
          <> */}
        <div className={styles.block} style={{ position: 'relative' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <FComponentsLib.FContentText
              text={
                // 基础属性
                FI18n.i18nNext.t('resourceinfo_title')
              }
              type={'highlight'}
            />

            {resourceCreatorPage.step2_customProperties.length < 30 && (
              <FTooltip title={FI18n.i18nNext.tAuto('resourceinfo_add_btn_info')}>
                <div>
                  <FComponentsLib.FTextBtn
                    style={{
                      fontSize: 12,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 5,
                    }}
                    type='primary'
                    onClick={async () => {
                      const dataSource: {
                        key: string;
                        name: string;
                        description: string;
                      } | null = await fResourcePropertyEditor3({
                        disabledKeys: [
                          ...resourceCreatorPage.step2_systemProperties.map<string>((bp) => bp.key),
                          ...resourceCreatorPage.step2_customProperties.map<string>((bp) => bp.key),
                          ...resourceCreatorPage.step2_customConfigurations.map<string>(
                            (pp) => pp.key,
                          ),
                        ],
                        disabledNames: [
                          ...resourceCreatorPage.step2_systemProperties.map<string>(
                            (bp) => bp.name,
                          ),
                          ...resourceCreatorPage.step2_customProperties.map<string>(
                            (bp) => bp.name,
                          ),
                          ...resourceCreatorPage.step2_customConfigurations.map<string>(
                            (pp) => pp.name,
                          ),
                        ],
                      });
                      if (!dataSource) {
                        return;
                      }

                      await dispatch<OnChange_step2_customProperties_Action>({
                        type: 'resourceCreatorPage/onChange_step2_customProperties',
                        payload: {
                          value: [
                            ...resourceCreatorPage.step2_customProperties,
                            { ...dataSource, value: '' },
                          ],
                        },
                      });
                    }}
                  >
                    <FIcons.FProperty style={{ fontSize: 14 }} />
                    <span>
                      {
                        // 补充属性
                        FI18n.i18nNext.tAuto('resourceinfo_add_title')
                      }
                    </span>
                  </FComponentsLib.FTextBtn>
                </div>
              </FTooltip>
            )}
          </div>

          {[
            ...resourceCreatorPage.step2_systemProperties.filter((rp) => {
              return !(rp.type === 'raw' && rp.value === '');
            }),
            ...resourceCreatorPage.step2_customProperties,
          ].length === 0 && (
            <>
              <div style={{ height: 10 }} />
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <FComponentsLib.FContentText
                  text={FI18n.i18nNext.t('resourceinfo_empty_msg')}
                  type={'additional2'}
                  style={{ maxWidth: 600, textAlign: 'center' }}
                />
              </div>
              <div style={{ height: 20 }} />
            </>
          )}

          {[
            ...resourceCreatorPage.step2_systemProperties,
            ...resourceCreatorPage.step2_customProperties,
          ].length > 0 && (
            <>
              <div style={{ height: 20 }} />
              <FAttrsAndConfigs
                dateSource={[
                  ...resourceCreatorPage.step2_systemProperties.map<IAttrsAndConfigsItem>((sp) => {
                    return {
                      key: sp.key,
                      value: sp.value,
                      name: sp.name,
                      description: sp.description,
                      configs: {
                        item_Deletable: false,
                        key_Editable: false,
                        name_Editable: false,
                        description_Editable: false,
                        value_Editable: (sp.type === 'additional' && sp.valueConfig) || false,
                      },
                    };
                  }),
                  ...resourceCreatorPage.step2_customProperties.map<IAttrsAndConfigsItem>((cp) => {
                    return {
                      key: cp.key,
                      value: cp.value,
                      name: cp.name,
                      description: cp.description,
                      configs: {
                        item_Deletable: true,
                        key_Editable: true,
                        name_Editable: true,
                        description_Editable: true,
                        value_Editable: {
                          text: {
                            nullable: true,
                            minLength: 0,
                            maxLength: 100,
                          },
                        },
                      },
                    };
                  }),
                ]}
                onChangeItem={(oldData, newData, index) => {
                  if (index < resourceCreatorPage.step2_systemProperties.length) {
                    const newDateSource = [...resourceCreatorPage.step2_systemProperties];
                    newDateSource[index] = {
                      key: newData.key,
                      name: newData.name,
                      value: newData.value,
                      description: newData.description,
                      type: resourceCreatorPage.step2_systemProperties[index].type,
                      valueConfig: resourceCreatorPage.step2_systemProperties[index].valueConfig,
                    };

                    dispatch<OnChange_step2_systemProperties_Action>({
                      type: 'resourceCreatorPage/onChange_step2_systemProperties',
                      payload: {
                        value: newDateSource,
                      },
                    });
                  } else {
                    const newDateSource = [...resourceCreatorPage.step2_customProperties];
                    newDateSource[index - resourceCreatorPage.step2_systemProperties.length] = {
                      key: newData.key,
                      name: newData.name,
                      value: newData.value,
                      description: newData.description,
                    };
                    dispatch<OnChange_step2_customProperties_Action>({
                      type: 'resourceCreatorPage/onChange_step2_customProperties',
                      payload: {
                        value: newDateSource,
                      },
                    });
                  }
                }}
                onDeleteItem={(value) => {
                  dispatch<OnChange_step2_customProperties_Action>({
                    type: 'resourceCreatorPage/onChange_step2_customProperties',
                    payload: {
                      value: resourceCreatorPage.step2_customProperties.filter((cp) => {
                        return cp.key !== value.key && cp.name !== value.name;
                      }),
                    },
                  });
                }}
                disabledKeys={[
                  ...resourceCreatorPage.step2_systemProperties.map<string>((rp) => rp.key),
                  ...resourceCreatorPage.step2_customProperties.map<string>((cp) => cp.key),
                  ...resourceCreatorPage.step2_customConfigurations.map<string>((cp) => cp.key),
                ]}
                disabledNames={[
                  ...resourceCreatorPage.step2_systemProperties.map<string>((rp) => rp.name),
                  ...resourceCreatorPage.step2_customProperties.map<string>((cp) => cp.name),
                  ...resourceCreatorPage.step2_customConfigurations.map<string>((cp) => cp.name),
                ]}
              />
            </>
          )}

          {resourceCreatorPage.step2_systemPropertiesState === 'parsing' && (
            <div className={styles.parsingTip}>
              <FIcons.FLoading style={{ fontSize: 14, color: '#E9A923' }} />
              <span>{FI18n.i18nNext.tAuto('creatversion_property_msg_backendprocessing')}</span>
            </div>
          )}
        </div>

        <div style={{ height: 15 }} />

        {$showMore ? (
          <FComponentsLib.FTextBtn
            style={{ fontSize: 12 }}
            type={'primary'}
            onClick={() => {
              set$ShowMore(false);
            }}
          >
            {FI18n.i18nNext.tAuto('create_new_version_btn_showless')}
          </FComponentsLib.FTextBtn>
        ) : (
          <Space size={10}>
            <FComponentsLib.FTextBtn
              style={{ fontSize: 12 }}
              type={'primary'}
              onClick={() => {
                set$ShowMore(true);
              }}
            >
              {
                // 更多设置
                FI18n.i18nNext.tAuto('create_new_version_btn_moresetting')
              }
            </FComponentsLib.FTextBtn>
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('create_new_version_btn_moresetting_help')}
              type={'additional2'}
            />
          </Space>
        )}
        {/* </>
        )} */}

        <div style={{ display: $showMore ? 'block' : 'none' }}>
          <div style={{ height: 10 }} />

          {resourceCreatorPage.step2_resourceTypeConfig.isSupportOptionalConfig && (
            <>
              <div className={styles.block}>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}
                >
                  <FComponentsLib.FContentText
                    text={FI18n.i18nNext.t('resourceoptions_title')}
                    type={'highlight'}
                  />
                  {resourceCreatorPage.step2_customConfigurations.length < 30 && (
                    <FTooltip title={FI18n.i18nNext.tAuto('info_versionoptions')}>
                      <div>
                        <FComponentsLib.FTextBtn
                          style={{
                            fontSize: 12,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5,
                          }}
                          type='primary'
                          onClick={async () => {
                            const dataSource: {
                              key: string;
                              name: string;
                              type: 'input' | 'select';
                              input: string;
                              select: string[];
                              description: string;
                            } | null = await fResourceOptionEditor({
                              disabledKeys: [
                                ...resourceCreatorPage.step2_systemProperties.map<string>(
                                  (sp) => sp.key,
                                ),
                                ...resourceCreatorPage.step2_customProperties.map<string>(
                                  (bp) => bp.key,
                                ),
                                ...resourceCreatorPage.step2_customConfigurations.map<string>(
                                  (pp) => pp.key,
                                ),
                              ],
                              disabledNames: [
                                ...resourceCreatorPage.step2_systemProperties.map<string>(
                                  (sp) => sp.name,
                                ),
                                ...resourceCreatorPage.step2_customProperties.map<string>(
                                  (bp) => bp.name,
                                ),
                                ...resourceCreatorPage.step2_customConfigurations.map<string>(
                                  (pp) => pp.name,
                                ),
                              ],
                            });

                            if (!dataSource) {
                              return;
                            }

                            await dispatch<OnChange_step2_customConfigurations_Action>({
                              type: 'resourceCreatorPage/onChange_step2_customConfigurations',
                              payload: {
                                value: [
                                  ...resourceCreatorPage.step2_customConfigurations,
                                  dataSource,
                                ],
                              },
                            });
                          }}
                        >
                          <FIcons.FConfiguration style={{ fontSize: 14 }} />
                          <span>{FI18n.i18nNext.tAuto('resourceoptions_add_btn')}</span>
                        </FComponentsLib.FTextBtn>
                      </div>
                    </FTooltip>
                  )}
                </div>

                {resourceCreatorPage.step2_customConfigurations.length === 0 && (
                  <>
                    <div style={{ height: 10 }} />
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <FComponentsLib.FContentText
                        text={FI18n.i18nNext.t('resourceoptions_list_empty')}
                        type={'additional2'}
                      />
                    </div>
                    <div style={{ height: 20 }} />
                  </>
                )}

                {resourceCreatorPage.step2_customConfigurations.length > 0 && (
                  <>
                    <div style={{ height: 20 }} />
                    <FResourceOptions
                      theme={'dark'}
                      dataSource={resourceCreatorPage.step2_customConfigurations}
                      onEdit={async (value) => {
                        const index: number =
                          resourceCreatorPage.step2_customConfigurations.findIndex((p) => {
                            return p === value;
                          });

                        const dataSource: {
                          key: string;
                          name: string;
                          type: 'input' | 'select';
                          input: string;
                          select: string[];
                          description: string;
                        } | null = await fResourceOptionEditor({
                          disabledKeys: [
                            ...resourceCreatorPage.step2_systemProperties.map<string>(
                              (sp) => sp.key,
                            ),
                            ...resourceCreatorPage.step2_customProperties.map<string>(
                              (bp) => bp.key,
                            ),
                            ...resourceCreatorPage.step2_customConfigurations.map<string>(
                              (pp) => pp.key,
                            ),
                          ],
                          disabledNames: [
                            ...resourceCreatorPage.step2_systemProperties.map<string>(
                              (sp) => sp.name,
                            ),
                            ...resourceCreatorPage.step2_customProperties.map<string>(
                              (bp) => bp.name,
                            ),
                            ...resourceCreatorPage.step2_customConfigurations.map<string>(
                              (pp) => pp.name,
                            ),
                          ],
                          defaultData: value,
                        });

                        if (!dataSource) {
                          return;
                        }

                        await dispatch<OnChange_step2_customConfigurations_Action>({
                          type: 'resourceCreatorPage/onChange_step2_customConfigurations',
                          payload: {
                            value: resourceCreatorPage.step2_customConfigurations.map((a, b) => {
                              if (b !== index) {
                                return a;
                              }
                              return dataSource;
                            }),
                          },
                        });
                      }}
                      onDelete={async (value) => {
                        await dispatch<OnChange_step2_customConfigurations_Action>({
                          type: 'resourceCreatorPage/onChange_step2_customConfigurations',
                          payload: {
                            value: resourceCreatorPage.step2_customConfigurations.filter((a) => {
                              return a.key !== value.key && a.name !== value.name;
                            }),
                          },
                        });
                      }}
                    />
                  </>
                )}
              </div>

              <div style={{ height: 5 }} />
            </>
          )}

          <div className={styles.block}>
            {resourceCreatorPage.step1_createdResourceInfo &&
              resourceCreatorPage.step2_authReload > 0 && (
                <FMicroAPP_Authorization
                  licenseeId={resourceCreatorPage.step1_createdResourceInfo.resourceID}
                  mainAppType={'resourceInVersionUpdate'}
                  depList={resourceCreatorPage.step2_directDependencies}
                  upcastList={resourceCreatorPage.step2_baseUpcastResources}
                  // mount={() => {}}
                  update={async (data) => {
                    dispatch<ChangeAction>({
                      type: 'resourceCreatorPage/change',
                      payload: {
                        step2_directDependencies: data.directDependencies || [],
                        step2_baseUpcastResources: data.baseUpcastResources || [],
                        step2_isCompleteAuthorization: data.isAllAuthComplete ?? true,
                        step2_dataIsDirty_count: resourceCreatorPage.step2_dataIsDirty_count + 1,
                        step2_authExcludedItems: data.authExcludedItems || [],
                      },
                    });
                  }}
                />
              )}
          </div>
        </div>

        <div style={{ height: 30 }} />

        <div className={styles.btn}>
          <FComponentsLib.FTextBtn
            type={'default'}
            onClick={() => {
              history.push(
                FUtil.LinkTo.resourceVersionInfo({
                  resourceID: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
                }),
              );
            }}
          >
            {FI18n.i18nNext.tAuto('rqr_step2_btn_later')}
          </FComponentsLib.FTextBtn>

          <FHotspotTooltip
            id={'resourceCreator.step2.submitButton'}
            style={{ left: 20, bottom: -38 }}
            text={
              <div style={{ minWidth: 110 }}>{FI18n.i18nNext.tAuto('hotpots_rqr_submitresource')}</div>
            }
            zIndex={100}
            onOpenChange={(o) => {
              if (o) {
                fSetHotspotTooltipVisible('resourceCreator.step2.submitButton', {
                  value: false,
                  effectiveImmediately: false,
                  onlyNullish: false,
                });
              }
            }}
          >
            <FComponentsLib.FRectBtn
              disabled={
                !resourceCreatorPage.step2_fileInfo ||
                !resourceCreatorPage.step2_isCompleteAuthorization
              }
              type={'primary'}
              onClick={() => {
                dispatch<OnClick_step2_submitBtn_Action>({
                  type: 'resourceCreatorPage/onClick_step2_submitBtn',
                });
              }}
            >
              {/*发行*/}
              {FI18n.i18nNext.tAuto('rqr_step2_btn_next')}
            </FComponentsLib.FRectBtn>
          </FHotspotTooltip>
        </div>

        <div style={{ height: 100 }} />

        <FMicroApp_MarkdownEditorDrawer
          open={resourceCreatorPage.step2_isOpenMarkdown}
          resourceID={resourceCreatorPage.step1_createdResourceInfo?.resourceID || ''}
          onChange_Saved={(saved) => {}}
          onClose={async () => {
            await dispatch<ChangeAction>({
              type: 'resourceCreatorPage/change',
              payload: {
                step2_authReload: 0,
              },
            });
            await dispatch<OnClose_step2_editMarkdown>({
              type: 'resourceCreatorPage/onClose_step2_editMarkdown',
            });
          }}
        />

        <FMicroApp_CartoonEditorDrawer
          open={resourceCreatorPage.step2_isOpenCartoon}
          resourceID={resourceCreatorPage.step1_createdResourceInfo?.resourceID || ''}
          onChange_Saved={(saved) => {}}
          onClose={() => {
            dispatch<OnClose_step2_editCartoon_Action>({
              type: 'resourceCreatorPage/onClose_step2_editCartoon',
            });
          }}
        />
      </div>
    </>
  );
}

export default connect(({ resourceCreatorPage }: ConnectState) => ({
  resourceCreatorPage: resourceCreatorPage,
}))(Step2);
